export default __webpack_public_path__ + "static/media/trail.ad681f59.svg";